var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"my-trips-header"},[_c('h1',{staticClass:"my-trips-header__title"},[_vm._v("Saved Trips")]),(_vm.isAmex)?_c('PilotEnds'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }